export const postFix = "_$";

/**
 * Returns true if both input are equal to each other. [Edge cases exists :/]
 * 
 * @param {Object} x
 * @param {object} y
 * @returns {*}
 */
function objectEquals(x, y) {
    if (x === null || x === undefined || y === null || y === undefined) { return x === y; }
    // after this just checking type of one would be enough
    if (x.constructor !== y.constructor) { return false; }
    // if they are functions, they should exactly refer to same one (because of closures)
    if (x instanceof Function) { return x === y; }
    // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
    if (x instanceof RegExp) { return x === y; }
    if (x === y || x.valueOf() === y.valueOf()) { return true; }
    if (Array.isArray(x) && x.length !== y.length) { return false; }

    // if they are dates, they must had equal valueOf
    if (x instanceof Date) { return false; }

    // if they are strictly equal, they both need to be object at least
    if (!(x instanceof Object)) { return false; }
    if (!(y instanceof Object)) { return false; }

    // recursive object equality check
    var p = Object.keys(x);
    return Object.keys(y).every(function (i) { return p.indexOf(i) !== -1; }) && p.every(function (i) { return objectEquals(x[i], y[i]); });
}

/**
 * Extraherar egenskapen från ett objekt.
 * 
 * @param {Object} source
 * @param {string|string[]} property
 * @returns {*}
 */
export function getPropertyValue(source, property) {
    if (!source || !property) {
        return undefined;
    }

    let prop = null;
    if (Array.isArray(property)) {
        let obj = source;
        for(let i=0; i<property.length; i++){
            if( i+1===property.length){
                obj = obj[`${property}${postFix}`]!==undefined ? obj[`${property[i]}${postFix}`] : obj[property[i]];
            } else {
                obj = obj[property[i]];
            }
            if (obj==null) {
                break;
            }
        }
        prop = obj;
    } else {
        prop = source[`${property}${postFix}`]!==undefined ? source[`${property}${postFix}`] : source[property];
    }

    return prop;
}

/**
 * Test if the property has changed
 * 
 * @param {Object} source
 * @param {string|string[]} property
 * @returns {*}
 */
export function isPropertyValueChanged(source, property) {
    if (!source || !property) {
        return undefined;
    }

    if (Array.isArray(property)) {
        let obj = source;
        for(let i=0; i<property.length; i++){
            if( i+1===property.length){
                return obj[`${property}${postFix}`]===undefined ? false : objectEquals(obj[property], obj[`${property}${postFix}`]);
            } else {
                obj = obj[property[i]];
            }
            if (!obj) {
                break;
            }
        }
    } else {
        return source[`${property}${postFix}`]===undefined ? false : !objectEquals(source[property], source[`${property}${postFix}`]);
    }

    return false;
}

/**
 * Skapar ett nytt objekt med vald egenskap och värde. Lämpligt att använda till en onEdit action.
 * 
 * @param {string|string[]} property 
 * @param {any} value 
 * @returns {nothing}
 */
export function makePropertyValue(property, value) {
    if (Array.isArray(property)) {
        const outerObject = {};
        let innerObject = outerObject;
        for (let idx = 0; idx < property.length - 1; idx++) {
            innerObject[property[idx]] = {};
            innerObject = innerObject[property[idx]];
        }
        innerObject[property[property.length - 1]] = value;
        return outerObject;
    } else {
        return {
            [property]: value
        };
    }
}